import { useContext, useEffect, useState } from "react";
import { AppContext } from "../context/AppContextProvider";
import { LoginBanner } from "../components/LoginBanner";
import ErrorBlock from "../components/ErrorBlock";
import { ProductCard } from "../components/ProductCard";
import DocsContainer from "../components/DocsContainer";
import { ActionTypes } from "../actions/actions";
import { Trans, useTranslation } from "react-i18next";
import Loader from "../components/Loader";
import { getProduct } from "../lib/api/api";
import { Divider } from "../components/Divider";
import { ServiceCard } from "../components/ServiceCard";
import i18n from "../i18n";

export default function Home() {
    const { state, dispatch } = useContext(AppContext);
    const { t } = useTranslation();
    const { resolvedLanguage } = i18n;
    const { product, docs } = state;
    const [loading, setLoading] = useState(false);

    const params = window.location.search;

    useEffect(() => {
        const urlParams = new URLSearchParams(params);
        const seriale = urlParams.get("sn");

        if (!seriale) return;

        dispatch({
            type: ActionTypes.SetProductProp,
            propName: "seriale",
            propValue: seriale
        })
    }, [params])

    useEffect(() => {
        async function loadProduct() {
            if (!product.seriale) return;

            try {
                setLoading(true);
                const response = await getProduct(product.seriale);

                if (response.error) {
                    throw new Error(response.message);
                }

                dispatch({
                    type: ActionTypes.SetProduct,
                    payload: {
                        ...response.data,
                        data_fine_costruzione: new Date(response.data.data_fine_costruzione)
                    },
                });
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }
        loadProduct();
    }, [product.seriale])

    if (loading) {
        return <Loader />
    }

    return (
        <div className="flex flex-col gap-[24px] md:gap-[32px] items-center justify-center">
            {product.seriale ?
                product.codice_articolo ?
                    <>
                        {docs.loaded && docs.items.length === 0 && <LoginBanner />}
                        <ProductCard />
                        <DocsContainer />

                        {resolvedLanguage === "it" &&
                            <>
                                <Divider
                                    text={t("service.needHelp")}
                                />
                                <ServiceCard />
                            </>
                        }

                    </>
                    : <NotFoundError />
                :
                <MissingSerialError />}
        </div>

    );
}

const NotFoundError = () => {
    const { t } = useTranslation();
    const { state } = useContext(AppContext);
    const { product } = state;

    return <ErrorBlock
        title={t("error.notFound.title")}
        buttonText={t("error.buttonText")}
        description={<>
            <p>
                <Trans
                    i18nKey={"error.notFound.part1" as any}
                    values={{ seriale: product.seriale }} />
                <br />
                <Trans i18nKey={"error.notFound.part2" as any} />
            </p>
            <br />
            <br />
            <ul className="w-fit mx-auto list-disc">
                <li>
                    <Trans i18nKey={"error.notFound.part3" as any} />
                </li>
                <li>
                    <Trans i18nKey={"error.notFound.part4" as any} />
                </li>
            </ul>
        </>} />;
}

const MissingSerialError = () => {
    const { t } = useTranslation();

    return <ErrorBlock
        title={t("error.missing.title")}
        buttonText={t("error.buttonText")}
        description={<p>
            <Trans
                i18nKey={"error.missing.part1" as any} />
            <br />
            <Trans
                i18nKey={"error.missing.part2" as any} />
        </p>} />;
}